export const processPhoneNumber = (maskedNumber) => {
  if(!maskedNumber) return '';
  return `+${maskedNumber.replace(/\D+/g, "")}`;
}

export const getQueryString = (query) => Object.entries(query)
  .filter(([, value]) => value)
  .map(([key, value]) => `${key}=${value}`)
  .join('&');
